import React, { Component, Fragment } from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { CREATE_EDIT_USAGE_FORM_NAME } from 'Common/FormEnum';
import {
  DATE_FORMAT_FOR_SERVER,
  UNSAVED_MESSAGE,
  DATE_FORMAT_FOR_UI,
} from 'Common/Constants';
import {
  NewEditUsageEnum,
  SiteStatusEnum,
} from 'Common/Constants/Enumeration/UsageListEnum';
import { FilterEnum, CreateEditUsageEnum } from 'Common/FieldEnum';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { resetForm } from 'State/forms/actions';
import * as FilterSelectors from 'State/filters/selectors';

import CreateEditUsageComponent from '../../components/createEditUsage/CreateEditUsage';
import { actions } from './../../state/actions';
import * as Selectors from '../../state/CreateEditUsage/selectors';

class CreateEditUsageContainer extends Component {
  static propTypes = {
    usageDT: PropTypes.string,
    Site: PropTypes.string,
    usageItemsInfo: PropTypes.array,
    assignItemsBidGroupData: PropTypes.array.isRequired,
    assignItemsItemGroupData: PropTypes.array.isRequired,
    usageItemsData: PropTypes.array.isRequired,
    selectedUsageDetail: PropTypes.object,
    fetchUsageItems: PropTypes.bool.isRequired,
    key: PropTypes.string,
    initialValues: PropTypes.object.isRequired,
    IsNewEdit: PropTypes.string,
    UsageId: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    resetPageOnDataChange: PropTypes.bool.isRequired,
    onResetPageOnDataChange: PropTypes.func,
    setPageResetState: PropTypes.func,
  };
  static defaultProps = {
    usageItemsInfo: [],
    usageDT: moment().format(DATE_FORMAT_FOR_UI),
    Site: '0',
    selectedUsageDetail: null,
    fetchUsageItems: false,
    onResetPageOnDataChange: () => {},
    setPageResetState: () => {},
    key: 'newEdit1',
    isDisabled: false,
    IsNewEdit: '0',
  };
  state = {
    showUnsavedSiteDateModal: false,
    showUnsavedFiltersModal: false,
    activeIndexForFilter: 0,
    usageDT: moment(),
    filterValues: {
      [FilterEnum.GroupId_Bid]: 0,
      [FilterEnum.GroupId_Item]: 0,
    },
    SiteAndDeliveryDate: {
      newValue: null,
      previousValue: null,
      field: '',
    },
  };

  onChangeOfDateAndSite = (event, newValue, previousValue, field) => {
    if (newValue === previousValue || !field) {
      return;
    }
    if (
      newValue !== previousValue &&
      previousValue !== NewEditUsageEnum.NEW &&
      this.props.usageItemsInfo.length
    ) {
      this.setState({
        showUnsavedSiteDateModal: true,
        SiteAndDeliveryDate: {
          newValue,
          previousValue,
          field,
        },
      });
    } else {
      this.handleOnSiteAndDeliveryDateChange({
        newValue,
        previousValue,
        field,
      });
    }
  };

  handleOnSiteAndDeliveryDateChange = obj => {
    const { newValue, field } = obj ? obj : this.state.SiteAndDeliveryDate;
    const { Site, usageDT } = this.props;

    let tempSiteId = Site;
    let delvDate = usageDT;
    if (field === CreateEditUsageEnum.Site) {
      tempSiteId = newValue;
    } else if (field === CreateEditUsageEnum.UsageDT) {
      delvDate = newValue;
    } else {
      return;
    }
    if (tempSiteId !== SiteStatusEnum.EMPTY && delvDate) {
      const filtersOptions = {
        SiteId: tempSiteId,
        DateUsage: moment(delvDate).format(DATE_FORMAT_FOR_SERVER),
      };
      this.props.getUsageItems(filtersOptions, false).then(() => {
        if (this.props.usageItemsInfo && this.props.usageItemsInfo.length) {
          let usageList = [];
          this.props.usageItemsData.forEach(item => {
            _.some(this.props.usageItemsInfo, obj => {
              if (
                item[CreateEditUsageEnum.ItemCode] ===
                obj[CreateEditUsageEnum.ItemCode]
              ) {
                usageList.push(obj);
                return true;
              }
            });
          });
          this.props.setModifiedUsageItems(usageList);
          this.props.reorderItemList(usageList);
        }
      });
    } else {
      this.props.emptyItemList();
    }
  };

  handleChange = (e, values) => {
    this.setState({ filterValues: values });
  };

  clearFilters = () => {
    this.setState({
      showUnsavedFiltersModal: true,
    });
  };

  handleUnsavedFilterDialog(result) {
    if (result) {
      this.props.clearUsageItemGridData();
      this.handleClearFilters();
    } else {
      this.setState({ showUnsavedFiltersModal: false });
    }
  }

  handleUnsavedSiteDateDialog = result => {
    if (result) {
      this.props.clearUsageItemGridData();
      this.setState({ showUnsavedSiteDateModal: false });
      this.handleOnSiteAndDeliveryDateChange();
      this.props.setPageResetState(true);
    } else {
      const { previousValue, field } = this.state.SiteAndDeliveryDate;
      field === CreateEditUsageEnum.Site
        ? this.props.change([CreateEditUsageEnum.Site], previousValue)
        : this.props.change([CreateEditUsageEnum.UsageDT], previousValue);
      this.setState({ showUnsavedSiteDateModal: false });
    }
  };

  handleClearFilters = () => {
    const { IsNewEdit, getUsageDetail, UsageId, getUsageItems } = this.props;

    let filterValues = {
      [FilterEnum.GroupId_Bid]: 0,
      [FilterEnum.GroupId_Item]: 0,
    };
    this.setState({
      filtered: [],
      filterValues,
      showUnsavedFiltersModal: false,
    });
    this.props.resetForm(CREATE_EDIT_USAGE_FORM_NAME);
    if (IsNewEdit !== NewEditUsageEnum.NEW) {
      getUsageDetail(UsageId).then(() => {
        const { selectedUsageDetail } = this.props;
        const filtersOptions = {
          SiteId: selectedUsageDetail[CreateEditUsageEnum.SiteId],
          DateUsage: moment(
            selectedUsageDetail[CreateEditUsageEnum.UsageDT]
          ).format(DATE_FORMAT_FOR_SERVER),
        };
        getUsageItems(
          filtersOptions,
          true,
          selectedUsageDetail[CreateEditUsageEnum.UsageItems]
        );
      });
    } else {
      this.props.emptyItemList();
    }
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexForFilter } = this.state;
    const newIndex = activeIndexForFilter === index ? -1 : index;
    this.setState({
      activeIndexForFilter: newIndex,
    });
  };

  render() {
    const {
      usageItemsData,
      assignItemsBidGroupData,
      assignItemsItemGroupData,
      fetchUsageItems,
      isDisabled,
      resetPageOnDataChange,
      onResetPageOnDataChange,
    } = this.props;

    const {
      showUnsavedFiltersModal,
      showUnsavedSiteDateModal,
      filterValues,
    } = this.state;

    const filterValuesData = {};
    _.map(filterValues, (value, key, items) => {
      if (+items[key]) {
        filterValuesData[key] = items[key];
      }
    });

    const newData = Object.keys(filterValuesData).length
      ? _.filter(usageItemsData, filterValuesData)
      : usageItemsData;

    return (
      <Fragment>
        <CreateEditUsageComponent
          usageItemsData={newData}
          assignItemsBidGroupData={assignItemsBidGroupData}
          assignItemsItemGroupData={assignItemsItemGroupData}
          onChangeOfSite={this.onChangeOfDateAndSite}
          onChangeOfUsageDT={this.onChangeOfDateAndSite}
          handleChange={this.handleChange}
          clearFilters={this.clearFilters}
          filterValues={filterValues}
          fetchUsageItems={fetchUsageItems}
          isDisabled={isDisabled}
          resetPageOnDataChange={resetPageOnDataChange}
          onResetPageOnDataChange={onResetPageOnDataChange}
          activeIndexForFilter={this.state.activeIndexForFilter}
          handleClick={this.handleClick}
        />
        <YesNoDialog
          showDialog={showUnsavedFiltersModal || showUnsavedSiteDateModal}
          title="Un-saved changes detected"
          question={UNSAVED_MESSAGE}
          yesCallback={() => {
            showUnsavedFiltersModal
              ? this.handleUnsavedFilterDialog(true)
              : this.handleUnsavedSiteDateDialog(true);
          }}
          noCallback={() => {
            showUnsavedFiltersModal
              ? this.handleUnsavedFilterDialog(false)
              : this.handleUnsavedSiteDateDialog(false);
          }}
        />
      </Fragment>
    );
  }
}

const selector = formValueSelector(CREATE_EDIT_USAGE_FORM_NAME);
const mapStateToProps = state => {
  return {
    usageDT: selector(state, [CreateEditUsageEnum.UsageDT]),
    Site: selector(state, [CreateEditUsageEnum.Site]),
    usageItemsInfo: selector(state, [CreateEditUsageEnum.UsageItemsInfo]),
    assignItemsBidGroupData: FilterSelectors.selectBidGroupData(state),
    assignItemsItemGroupData: FilterSelectors.selectItemGroupData(state),
    usageItemsData: Selectors.getUsageItems(state),
    selectedUsageDetail: Selectors.getSelectedUsageDetail(state),
    fetchUsageItems: Selectors.getFetchUsageItems(state),
  };
};

CreateEditUsageContainer = reduxForm({
  form: CREATE_EDIT_USAGE_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(CreateEditUsageContainer);

const mapDispatchToProps = {
  ...actions,
  resetForm,
};
export const CreateEditUsage = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateEditUsageContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/containers/createEditUsage/CreateEditUsage.js